import { ReactComponent as LicenceIconSvg } from "./icon_licence.svg";
const LicenceIcon = (props) => {
  return <LicenceIconSvg {...props} />;
};
export default LicenceIcon;
